import { Alert, Stack, TextField, Typography } from "@mui/material";
import Frame from "../Frames/Basic";
import Address from "../Inputs/Address";
import Siret from "../Inputs/Siret";
import { useContext } from "react";
import { LoadingButton } from "@mui/lab";
import { useState } from "react";
import API from "../../services/API"
import { Navigate } from "react-router-dom";
import UserContext from "../../services/Context/UserContext";
import JWT from "../../services/JWT";

export default function Organize(){

    const {user, setUser} = useContext(UserContext)

    const [status, setStatus] = useState('ready')

    const handleSubmit = e => {
        e.preventDefault();
        
        setStatus('submit')

        API.put('/organize', user)
            .then(r => {
                console.log(r.data)
                setUser(r.data)
                JWT.setTokens(r.data)
                setStatus('success')
            })
            .catch(_ => setStatus('error'))
    }

    if( status === 'success') return <Navigate to='/'/>

    return <Frame center>

        <form onSubmit={handleSubmit}>

            <Stack spacing={3} sx={{maxWidth: 500, margin: 'auto'}}>

                <Typography variant='h1'>Organiser des événements</Typography>

                <Typography>Veuillez vérifier les informations de votre entreprise pour créer des événements.</Typography>

                {status === 'error' && 
                    <Alert severity='error'>Une erreur s'est produite. Vérifiez vos informations.</Alert>
                }

                <TextField 
                    label="Nom de l'entreprise"
                    value={user.companyName || ''}
                    onChange={e => setUser({...user, companyName: e.target.value})}
                    required 
                    inputProps={{maxLength: 100}}
                    size='small'
                />

                <Siret 
                    value={user?.siret}
                    onChange={siret => setUser({...user, siret})}
                    required
                />

                <Address
                    value={user}
                    onChange={data => setUser(data)}
                />

                <LoadingButton
                    type='submit'
                    variant='contained'
                    loading={status === 'submit'}
                >
                    Valider
                </LoadingButton>

            </Stack>

        </form>

    </Frame>
}